import React, { useEffect, useRef, useState } from "react";
import { Button, Field } from "@fluentui/react-components";
import { useTaskPane } from "../../provider/TaskPaneProvider";
import { handleKeyNumberPress } from "../../../utils/formats";

const TaskForm = ({ updateState }) => {
  const inputRef = useRef(null);
  const inputRefDue = useRef(null);
  const [startDaysToAdd, setStartDaysToAdd] = useState(null);
  const [dueDaysToAdd, setDueDaysToAdd] = useState(null);
  const { queues, userGroups, user, taskPaneState, taskTypes, priorityList } = useTaskPane();
  console.log('taskPaneState', taskPaneState);
  console.log('user', user);
  console.log('queues', queues);
  const addDays = (dateStr, days) => {
    const date = new Date(dateStr);
    date.setDate(date.getDate() + parseInt(days || 0));
    return date.toISOString().split("T")[0];
  };

 const handleApplyDays = () => {
    if (startDaysToAdd) {
      const newDate = addDays(taskPaneState.taskStartDate? taskPaneState.taskStartDate: new Date(), startDaysToAdd);
      updateState("taskStartDate", newDate);
    }
    if (dueDaysToAdd) {
      const newDate = addDays(taskPaneState.taskDueDate? taskPaneState.taskDueDate : new Date(), dueDaysToAdd);
      updateState("taskDueDate", newDate);
    }
    if(inputRef?.current) inputRef.current.value = null;
    if(inputRef?.current) inputRefDue.current.value = null;
    setStartDaysToAdd(null);
    setDueDaysToAdd(null);
  };

  useEffect(() => {
    if (taskPaneState.sameAsDocDesc) {
      updateState("taskSubject", taskPaneState?.docDescription || "");
    } else updateState("taskSubject", "");

  }, [taskPaneState.sameAsDocDesc])

  return (
    <>
      {/* Subject Row */}
      <div className="text-left block text-gray-600 text-sm font-medium mb-1">
        <label className="h3-text text-sm text-gray-700 flex items-center">
          <input
            type="checkbox"
            checked={taskPaneState.taskChecked}
            onChange={(e) => updateState("taskChecked", e.target.checked)}
            className="mr-2"
          />
          Task
        </label>  
      </div>
        {taskPaneState.taskChecked && <>
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-1 sm:mt-0 lg:mt-0 mt-3">
            <div className="col-span-2 flex flex-row items-center">
          <label htmlFor="taskSubject" style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Subject</label>
        <Field className="col-span-2 items-center gap-1 w-full">
          <input
            id="taskSubject"
            type="text"
            disabled={taskPaneState?.sameAsDocDesc}
            value={taskPaneState.taskSubject}
            onChange={(e) => updateState("taskSubject", e.target.value)}
            placeholder="Enter subject"
            className="input-layout rounded py-1 px-2 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
          />
        </Field>
        </div>
        <div className="mt-0 flex flex-row items-center">
          <label className="h3-text text-gray-600 flex items-center mt-2 sm:mt-0 space-x-2">
            <input
              disabled={!taskPaneState?.taskChecked}
              type="checkbox"
              checked={taskPaneState.sameAsDocDesc}
              onChange={(e) => updateState("sameAsDocDesc", e.target.checked)}
              className="mr-2"
            />
            <span className="h3-text">  Same as Doc Desc</span>
          </label>
        </div>

      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-1 mt-1">

          <div className="grid grid-cols-1 sm:mt-0 lg:mt-0 mt-3 sm:grid-cols-1 lg:grid-cols-1 gap-1">
               <div className="col-span-2 flex flex-row items-center">
          <label htmlFor="userGroupId" style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">User Group</label>
            <Field className="items-center  gap-1 w-full">
              <select
                id="userGroupId"
                disabled={!taskPaneState?.taskChecked || !userGroups.length}
                value={taskPaneState.userGroupId}
                onChange={(e) => updateState("userGroupId", e.target.value)}
                className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
              // disabled={!userGroups.length}
              >
                <option value="">Select</option>
                {userGroups?.map((ug) => (
                  <option key={ug.userGroupID} value={ug.userGroupID}>
                    {ug.description}
                  </option>
                ))}
              </select>
            </Field>
            </div>
               <div className="col-span-2 flex flex-row items-center">
          <label htmlFor="taskUser" style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">User</label>
            <Field className="items-center  gap-1 w-full">
              <select
                id="taskUser"
                value={taskPaneState.userGroup}
                onChange={(e) => {
                   if(taskPaneState.taskQueue) updateState("taskQueue", "");
                   updateState("userGroup", e.target.value)}
                }
                className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
                // disabled={!userGroups.length}
                disabled={!taskPaneState?.taskChecked || !user?.length || !taskPaneState?.userGroupId}
              >
                  <option value="">Select</option>
                {user?.map((ug) => (
                  <option key={ug.userID} value={ug.userID}>
                    {ug.userName}
                  </option>
                ))}
              </select>
            </Field>
            </div>


               <div className="col-span-2 flex flex-row items-center">
          <label htmlFor="taskQueue" style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Queue</label>
            <Field className="items-center  gap-1 w-full">
              <select
                id="taskQueue"
                value={taskPaneState.taskQueue}
                onChange={(e) => {
                  if(taskPaneState.userGroup) updateState("userGroup", "");
                  updateState("taskQueue", e.target.value);
                }}
                className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
                // disabled={!queues.length}
                disabled={!taskPaneState?.taskChecked || !queues?.length || !taskPaneState?.userGroupId}
              >
                  <option value="">Select</option>
                {queues.map((qu) => (
                  <option key={qu.imgCommonQueueID} value={qu.imgCommonQueueID}>
                    {qu.queueName}
                  </option>
                ))}
              </select>
            </Field>
            </div>
               <div className="col-span-2 flex flex-row items-center">
          <label htmlFor="taskType" style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Task Type</label>
            <Field className="items-center  gap-1 w-full">
              <select
                disabled={!taskPaneState?.taskChecked || !taskTypes?.length || !taskPaneState?.userGroupId}
                id="taskType"
                value={taskPaneState.taskType}
                onChange={(e) => updateState("taskType", e.target.value)}
                className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
              >
                  <option value="">Select</option>
                {taskTypes.map((tt) => (
                  <option key={tt.taskTypeId} value={tt.taskTypeId}>
                    {tt.description}
                  </option>
                ))}
              </select>
            </Field>
            </div>
          </div>
          {/* Note */}
          <div className="grid grid-cols-1 sm:mt-0 lg:mt-0 mt-3 sm:grid-cols-1 lg:grid-cols-1 gap-1">
               <div className="flex flex-row">
          <label htmlFor="taskNote" style={{ minWidth: '8rem', marginTop: '6px' }} className="pl:0 sm:pl-8 h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-0 w-30">Note</label>
            <Field className="items-center gap-1 w-full">
              <textarea
                id="taskNote"
                disabled={!taskPaneState?.taskChecked}
                value={taskPaneState.taskNote}
                onChange={(e) => updateState("taskNote", e.target.value)}
                className="shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full mb-1 resize-none"
                rows={4}
                style={{ lineHeight: '1.1rem' }}
              />
            </Field>
            </div>
                      {/* <Field className="h3-text" label="Priority"> */}
              <div className="flex flex-row items-center">
          <label htmlFor="taskPriority" style={{ minWidth: '8rem' }} className="pl:0 sm:pl-8 h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Priority </label>
            <Field className="items-center  gap-1 w-full" style={{ display: 'flex', flexDirection: 'column' }}>
              <select
                disabled={!taskPaneState?.taskChecked}
                id="taskPriority"
                value={taskPaneState.taskPriority}
                onChange={(e) => updateState("taskPriority", e.target.value)}
                 className="input-layout shadow-sm border rounded py-1 px-2 text-sm w-full sm:w-50 lg:w-auto"
              >
                  <option value="">Select</option>
                {priorityList?.map((ug) => (
                  <option key={ug.priorityId} value={ug.priorityId}>
                    {ug.priorityDescription}
                  </option>
                ))}
              </select>
            </Field>
            </div>
            </div>
      </div>

<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-1 mt-1">
            {/* Due Date */}
               <div className="flex flex-row items-center">
          <label htmlFor="taskDueDate" style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Due Date </label>
           <Field className="items-center gap-1 w-full">
            <input
              disabled={!taskPaneState?.taskChecked}
              min="1900-01-01"
              id="taskDueDate"
              type="date"
              value={taskPaneState.taskDueDate}
              onChange={(e) => updateState("taskDueDate", e.target.value)}
              className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
            />
          </Field>
          </div>
          {/* Start Date */}
               <div className="flex flex-row items-center">
          <label htmlFor="taskStartDate" style={{ minWidth: '8rem' }} className="pl:0 sm:pl-8 h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Start Date </label>
           <Field className="items-center gap-1 w-full">
            <input
              disabled={!taskPaneState?.taskChecked}
              min="1900-01-01"
              id="taskStartDate"
              type="date"
              value={taskPaneState.taskStartDate}
              onChange={(e) => updateState("taskStartDate", e.target.value)}
              className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
            />
          </Field>
          </div>
               <div className="flex flex-row items-center">
          <label htmlFor="dueDaysToAdd" style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Add # of days </label>
            <Field className="items-center gap-2 w-full">
            <input
              // disabled={!taskPaneState?.taskChecked}
              id="dueDaysToAdd"
              ref={inputRefDue}
              type="text"
              onKeyPress={handleKeyNumberPress}
              placeholder="+days"
              value={dueDaysToAdd}
              onChange={(e) => setDueDaysToAdd(e.target.value)}
              className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
            />
          </Field>
          </div>
               <div className="flex flex-row items-center">
          <label htmlFor="startDaysToAdd" style={{ minWidth: '8rem' }} className="pl:0 sm:pl-8 h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Add # of days </label>
            <Field className="items-center gap-2 w-full">
            <input
              id="startDaysToAdd"
              ref={inputRef}
              // disabled={!taskPaneState?.taskChecked}
              onKeyPress={handleKeyNumberPress}
              placeholder="+days"
              value={startDaysToAdd}
              onChange={(e) => setStartDaysToAdd(e.target.value)}
              className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
            />
          </Field>
          </div>
</div>
          <div className="flex justify-end mt-1">
        <Button
            disabled={!((startDaysToAdd) || (dueDaysToAdd))}
            onClick={handleApplyDays}
            className={`${(!((startDaysToAdd) || (dueDaysToAdd)))? "btn-com-disable": "btn-com"}`}
          >
            Apply
          </Button>
            </div>
</>}
    </>
  );
};

export default TaskForm;
